( function( $ ) {
  if ( $( '.__timeline' ).length > 0  ) {
    $( '.__timeline--year' ).slick( {
      slidesToShow   : 1,
      slidesToScroll : 1,
      infinite       : false,
      vertical       : true,
      // verticalSwiping: true,
      fade           : false,
      adaptiveHeight : true,
      prevArrow      : '<button type="button" class="slick-prev"><i class="fas fa-chevron-up"></i></button>',
      nextArrow      : '<button type="button" class="slick-next"><i class="fas fa-chevron-down"></i></button>',
      responsive: [
        {
          breakpoint: 640,
          settings: {
            vertical       : false,
            fade           : true,
          }
        }
      ]
    } );

    $('.__timeline--year').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $( 'html, body' ).animate( {
        scrollTop: $( '.__timeline' ).offset().top - 80
      }, 1000 );
    });

    /* For Vertical Sliding effect */
    var responsiveTimeline = debounce( function() {
      if( $( window ).width() >= 623 ) {
        $( '.__timeline--year' )[0].slick.refresh();

        var heights = $( '.__timeline--year .slick-slide' ).map( function( i, el ) {
          return $( el ).outerHeight();
        } ).get();

        $( '.__timeline--year .slick-slide' ).height( Math.max.apply( Math, heights ) + 10 );
      }
    }, 250);

    if( $( window ).width() >= 640 )
      responsiveTimeline();

    window.addEventListener('resize', responsiveTimeline );
  }
} ) ( jQuery );